import {
  DocumentsEmployeeFilterDataDocument,
  DocumentsEmployeeFilterDataQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type EmployeeFilterOption =
  DocumentsEmployeeFilterDataQuery['employees']['employeeNames'][number]

export const useGetEmployeesFilterData = ({ skip }: { skip?: boolean } = {}) => {
  const { data, loading } = useQuery(DocumentsEmployeeFilterDataDocument, { skip })

  return {
    employees: data?.employees?.employeeNames ?? [],
    loading,
  }
}
